// @flow
import React, { type Node } from 'react'

import * as types from 'app/common/constants/identifiers/types'

import CardMarks from './icons/card_marks.svg'
import KeychainMarks from './icons/keychain_marks.svg'
import BraceletMarks from './icons/bracelet_marks.svg'
import CardBankMarks from './icons/card_bank_marks.svg'
import VirtualCardMarks from './icons/virtual_card_marks.svg'
import SmartWatchMarks from './icons/smart_watch_marks.svg'
import TinkoffCardMarks from './icons/tinkoff_card_marks.svg'

type Props = {
  type: $Values<typeof types>,
  className?: string,
}

const MarkByType = ({ type, className }: Props): Node => {
  switch (type) {
    case types.IDENTIFIER_CARD:
    case types.IDENTIFIER_RFID_CARD:
    case types.IDENTIFIER_SCHOOL_CARD:
      return <CardMarks className={className} />

    case types.IDENTIFIER_BANK_CARD:
    case types.IDENTIFIER_SBERBANK_CARD:
      return <CardBankMarks className={className} />

    case types.IDENTIFIER_KEYCHAIN_LEATHER:
    case types.IDENTIFIER_KEYCHAIN:
      return <KeychainMarks className={className} />

    case types.IDENTIFIER_BRACELET_LEATHER:
    case types.IDENTIFIER_BRACELET_SILICONE:
    case types.IDENTIFIER_BRACELET_KHAKI:
    case types.IDENTIFIER_SCHOOL_BRACELET:
      return <BraceletMarks className={className} />

    case types.IDENTIFIER_VIRTUAL_CARD:
      return <VirtualCardMarks className={className} />

    case types.IDENTIFIER_RFID_TAG:
      return null

    case types.IDENTIFIER_SMART_WATCH:
    case types.IDENTIFIER_BRACELET_FITNESS:
      return <SmartWatchMarks className={className} />

    case types.IDENTIFIER_TINKOFF:
      return <TinkoffCardMarks className={className} />

    case types.IDENTIFIER_USER_PHOTO:
      return null

    default:
  }

  return <CardMarks className={className} />
}

export default MarkByType
